import axios, {
  type AxiosInstance,
  type AxiosResponse,
  type InternalAxiosRequestConfig,
} from 'axios';

import { getApiConfig } from '../config/apiConfig';
import { getTokenManager } from '../config/tokenManager';
import { addLoggingInterceptors } from './logger';
export const publicApiClient: AxiosInstance = axios.create({
  baseURL: getApiConfig().apiBaseUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: {
    indexes: null,
  },
});

publicApiClient.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    config.baseURL = getApiConfig().apiBaseUrl;
    return config;
  },
  (error) => {
    getTokenManager().logger.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling and token refresh
publicApiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  async (error) => {
    // Handle other errors
    // if (error.response?.status >= 500) {
    //   getTokenManager().logger.error('Server error:', error.response.data);
    // } else if (error.response?.status >= 400) {
    //   getTokenManager().logger.error('Client error:', error.response.data);
    // }

    return Promise.reject(error);
  }
);

addLoggingInterceptors(publicApiClient, 'publicApiClient');
